import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import AristaForm from './ModificacionArista/AristaFormComponent';
import { putArista } from '../routing/routes';

const NuevaArista = ({ nodos, archivos, functionesChatbot, setNotification, refreshData }) => {
	const { id } = useParams();
	const history = useHistory();
	const nodo = nodos.find((nodo) => nodo._id === id);
	function guardarArista(nuevaArista) {
		const temp = { ...nodo };
		temp.aristas = [...nodo.aristas, nuevaArista];
		delete temp._id
		putArista(nodo._id, temp)
			.then(() => {
				history.push('/edit/' + nodo._id);
				setNotification('mArista creada correctamente!');
				setTimeout(refreshData, 1000);
			})
			.catch((error) => {
				setNotification('eOcurrió un error creando la arista!');
				console.error('Error:', error);
			});
	}

	if (nodo) {
		const aristaDefault = { scripts: [], nodoDestino: 0, nombre: '', operacion: '', condiciones: [] };
		return (
			<AristaForm
				nodo={nodo}
				arista={aristaDefault}
				nodos={nodos}
				guardarArista={guardarArista}
				editing={false}
				archivos={archivos}
				functionesChatbot={functionesChatbot}
			/>
		);
	} else {
		return <p>Loading...</p>;
	}
};
export default NuevaArista;
